module.exports = {
  submit: {
    // all: {
    //   saveTimeRecordings: 'Zeiterfassung speichern',
    // },
    resetUser: {
      all: 'Passwort zurücksetzen',
    },
    // timeRecord: {
    //   all: 'Eintrag übernehmen',
    // },
    // application: {
    //   showRegister: 'Bewerbung abschließen',
    //   showRegisterStep: 'Speichern & Weiter',
    // },
    // registration: {
    //   showRegister: 'Registrierung abschließen',
    // },
    // saveTimeRecordings: {
    //   timeRegistration: 'Zeiterfassung speichern',
    //   shippingOrder: 'Lieferschein-Zeiten speichern',
    // },
  },
  preview: {
    all: {
        all: 'Vorschau',
    },
    documentUrl: {
        all: 'Vorschau',
        link: 'Vorschau',
    },
  },
  download: {
    all: {
        all: 'Herunterladen',
    },
    documentUrl: {
        all: 'Herunterladen',
        pdf: 'PDF',
    },
  },
  // TODO: check if in use,
  // decisionComponent: {
  //   all: {
  //     all: 'Senden',
  //   },
  // },
  // showReplace: {
  //   shippingOrders: {
  //     all: 'Lieferschein ersetzen',
  //   },
  // },
  // export: {
  //   employee: {
  //     all: 'Mitarbeiter exportieren',
  //     workHours: 'Stundenlisten exportieren',
  //   },
  // },
  showInsert: {
    trips: {
      all: 'Fahrt',
    },
    tripDriverVessels: {
      all: 'Fahrer / Kennzeichen',
    },
    tripCostCenters: {
      all: 'Position',
    },
    tripStages: {
      all: 'Position',
    },
    schoolVacation: {
      all: 'Ferien',
    },
    drivers: {
      all: 'Fahrer',
    },
  },
  showEdit: {
    trips: {
      all: 'Fahrt bearbeiten',
    },
    tripDriverVessels: {
      all: 'Fahrer / Kennzeichen bearbeiten',
    },
    tripCostCenters: {
      all: 'Kostenstelle bearbeiten',
    },
    tripStages: {
      all: 'Etappe bearbeiten',
    },
    schoolVacation: {
      all: 'Ferien-Zeitraum bearbeiten',
    },
    drivers: {
      all: 'Fahrer bearbeiten',
    },
    // documents: {
    //   invoice: 'Rechnung bearbeiten',
    // },
  },
  // showExport: {
  // },
  showDuplicateOptions: {
    all: {
      all: 'Duplizieren',
    },
    trips: {
      all: 'Fahrt duplizieren',
    },
  },
  showExportOptions: {
    all: {
      all: 'Exportieren',
    },
    trips: {
      all: 'Dienstplan',
    },
  },
  delete: {
    trips: {
      all: 'Fahrt löschen',
    },
    tripDriverVessels: {
      all: 'Fahrer / Kennzeichen löschen',
    },
    tripCostCenters: {
      all: 'Kostenstelle löschen',
    },
    tripStages: {
      all: 'Etappe löschen',
    },
    schoolVacation: {
      all: 'Ferien-Zeitraum löschen',
    },
    drivers: {
      all: 'Fahrer löschen',
    },
  },
  lazyload: {
    trips: {
      all: 'Weitere Fahrten laden',
    },
    tripDriverVessels: {
      all: 'Weitere Fahrer / Kennzeichen laden',
    },
    tripDriverVesselConflicts: {
      all: 'Weitere Datensätze laden',
    },
    tripCostCenters: {
      all: 'Weitere Kostenstellen laden',
    },
    tripStages: {
      all: 'Weitere Etappen laden',
    },
    schoolVacation: {
      all: 'Weitere Ferien-Zeiträume laden',
    },
    drivers: {
      all: 'Weitere Fahrer laden',
    },
    // documents: {
    //   all: 'Weitere Dokumente laden',
    // },
  },
  selectAlternativeTab: {
    all: {
      all: 'Tab wechseln',
    },
  },
  // download: {
  //   all: {
  //     invoice: 'Rechnung herunterladen',
  //     creditNote: 'Gutschrift herunterladen',
  //   },
  // },
  showAdminPanel: {
    all: {
      all: 'Admin Panel öffnen',
    },
  },
  updateAllStatusFlags: {
    all: {
      all: 'Update All Status-Flags',
    },
  },
}